import TextHint from './TextHint';

export default TextHint;
